import { Card } from "@chakra-ui/react"
import { NormalUserContainer } from "../../styleComponents/NormalUserStyle"
import { useSelector } from "react-redux"
import AppCreate from "../../sections/AppCreate";
import { useState } from "react";
import Axios from "../../utils/httpClient";
import { useEffect } from "react";
import { monthList } from "../../sections/MonthShow";

const NormalUser = () => {
    const { user } = useSelector(s => s);
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(false);
    const isDepartmentHead = user?.role === 2;

    console.log('NormalUser component - isDepartmentHead:', isDepartmentHead, 'user role:', user?.role);

    useEffect(() => {
        getApps()
    }, [])

    const getApps = () => {
        setLoading(true);
        const endpoint = isDepartmentHead ? 'api/v1/application/check-list/' : 'api/v1/application/list/';
        Axios().get(endpoint)
            .then(res => {
                setApps(res?.data?.applications ?? [])
            }).catch(e => {

            }).finally(() => {
                setLoading(false);
            })
    }

    // Calculate status counts based on user role
    const statusCounts = isDepartmentHead ? {
        // For department heads
        kelibTushganlar: apps.filter(app => app.status === 1 || app.status === 2 || app.status === 3).length, // Incoming (pending evaluation)
        tasdiqlanganlar: apps.filter(app => {
            // Check if this department has approved
            const departmentName = user?.partition?.name?.toLowerCase() || "";
            const isTT = departmentName.includes("tarmoq texnologiyalari");
            const isTS = departmentName.includes("ta'lim sifati") || departmentName.includes("talim sifati");
            const isOV = departmentName.includes("o'quv") || departmentName.includes("oquv");
            const isMN = departmentName.includes("ma'naviyat") || departmentName.includes("manaviyat");
            const isXL = departmentName.includes("xalqaro hamkorlik");
            const isIL = departmentName.includes("ilmiy bo'lim");

            const code = app?.parameter?.code;
            if (code === '1.1') {
                if (isTT) return app.tt_status === 1;
                if (isTS) return app.ts_status === 1;
                if (isOV) return app.ov_status === 1;
            } else if (code === '1.3' || code === '1.4') {
                if (isMN) return app.mn_status === 1;
                if (isOV) return app.ov_status === 1;
            } else if (code === '3.2' || code === '3.3') {
                if (isOV) return app.ov_status === 1;
                if (isXL) return app.tt_status === 1;
                if (isIL) return app.ts_status === 1;
            } else if (code === '3.4' || code === '3.1' || code === '2.1') {
                if (isXL) return app.tt_status === 1;
                if (isIL) return app.ts_status === 1;
            } else {
                return app.status === 4;
            }
            return false;
        }).length,
        radEtilganlar: apps.filter(app => {
            // Check if this department has rejected
            const departmentName = user?.partition?.name?.toLowerCase() || "";
            const isTT = departmentName.includes("tarmoq texnologiyalari");
            const isTS = departmentName.includes("ta'lim sifati") || departmentName.includes("talim sifati");
            const isOV = departmentName.includes("o'quv") || departmentName.includes("oquv");
            const isMN = departmentName.includes("ma'naviyat") || departmentName.includes("manaviyat");
            const isXL = departmentName.includes("xalqaro hamkorlik");
            const isIL = departmentName.includes("ilmiy bo'lim");

            const code = app?.parameter?.code;
            if (code === '1.1') {
                if (isTT) return app.tt_status === 2;
                if (isTS) return app.ts_status === 2;
                if (isOV) return app.ov_status === 2;
            } else if (code === '1.3' || code === '1.4') {
                if (isMN) return app.mn_status === 2;
                if (isOV) return app.ov_status === 2;
            } else if (code === '3.2' || code === '3.3') {
                if (isOV) return app.ov_status === 2;
                if (isXL) return app.tt_status === 2;
                if (isIL) return app.ts_status === 2;
            } else if (code === '3.4' || code === '3.1' || code === '2.1') {
                if (isXL) return app.tt_status === 2;
                if (isIL) return app.ts_status === 2;
            } else {
                return app.status === 5;
            }
            return false;
        }).length
    } : {
        // For regular teachers
        bajarilganlar: apps.filter(app => app.status !== 6).length, // All submitted applications (exclude status=6 requirements)
        tasdiqlanganlar: apps.filter(app => app.status === 2 || app.status === 3 || app.status === 4).length, // Approved
        radEtilganlar: apps.filter(app =>
            app.status === 5 || // Currently rejected
            (app.rejected_at && app.status === 1) // Was rejected and resubmitted (status changed back to 1)
        ).length
    };

    const now_date = new Date();
    return (<>
        <NormalUserContainer>
            <Card>
                {!isDepartmentHead && (
                    <>
                        <div className="ball">{user?.total_ball ?? 0} Ball</div>
                        <div className="date">Jami ball</div>
                    </>
                )}

                {/* Status categories */}
                <div className="status-categories">
                    {isDepartmentHead ? (
                        <>
                            <div className="status-item bajarilganlar">
                                <span className="status-label">Kelib tushganlar:</span>
                                <span className="status-count">{statusCounts.kelibTushganlar}</span>
                            </div>
                            <div className="status-item tasdiqlanganlar">
                                <span className="status-label">Tasdiqlanganlar:</span>
                                <span className="status-count">{statusCounts.tasdiqlanganlar}</span>
                            </div>
                            <div className="status-item rad-etilganlar">
                                <span className="status-label">Rad etilganlar:</span>
                                <span className="status-count">{statusCounts.radEtilganlar}</span>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="status-item bajarilganlar">
                                <span className="status-label">Bajarilganlar:</span>
                                <span className="status-count">{statusCounts.bajarilganlar}</span>
                            </div>
                            <div className="status-item tasdiqlanganlar">
                                <span className="status-label">Tasdiqlanganlar:</span>
                                <span className="status-count">{statusCounts.tasdiqlanganlar}</span>
                            </div>
                            <div className="status-item rad-etilganlar">
                                <span className="status-label">Rad etilganlar:</span>
                                <span className="status-count">{statusCounts.radEtilganlar}</span>
                            </div>
                        </>
                    )}
                </div>
            </Card>
            <AppCreate getApps={getApps} />

        </NormalUserContainer>
    </>)
}
export default NormalUser